import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { Field, Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import FixedDropdown from '~/components/FixedDropdown';
import { useApi, useWorkspace } from '~/contexts';
import TaskDetails from './TaskDetails';

export default function BulkChangeCategory({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Change Task Category"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={TaskDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ taskCategory: null }}
        onSubmit={async (values) => {
          return api.www
            .workspaces(workspace.id)
            .projects(projectId)
            .tasks()
            .bulkSetTaskCategory(ids, { projectTaskCategoryId: values.taskCategory.id })
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          taskCategory: Yup.object().label('Task Category').nullable().required(),
        })}>
        {() => (
          <Form>
            <p>
              Change the task category of {ids.length} {pluralize('task', ids.length)} to:
            </p>

            <Form.Control>
              <Field.ProjectTaskCategorySelect
                name="taskCategory"
                placeholder="Task Category"
                clearable={false}
                component={FixedDropdown}
              />
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
